// models component
import Ship from '@/models/Ship.js'
import ShipSailor from '@/models/ShipSailor'
import ShipLaborWork from '@/models/ShipLaborWork'
import SelectShip from '@/models/SelectShip'

export default class LaborRecordbook {
    static organizationId = ''

    // Ship Sailors Fetch
    static of(shipId) {
        this.organizationId = Ship.findById(shipId).organizationId;
        return Promise.all([
            ShipSailor.api().list(shipId, true, 'laborRecord'),
            ShipLaborWork.api().fetch(shipId),
            SelectShip.api().fetch(this.organizationId)
        ])
        .catch(() => {
            return new Promise((resolve, reject) => {
                reject(new Error())
            })
        })
    }

    // // Ship Sailors Fetch
    // static of(shipId) {
    //     return Promise.resolve()
    //         .then(() => {
    //             return Ship.api()
    //                 .fetch()
    //                 .then((res) => {
    //                     this.organizationId =
    //                         res.entities.Ships[0].organizationId
    //                 })
    //         })
    //         .then(() => {
    //             return ShipSailor.api().list(shipId, true)
    //         })
    //         .then(() => {
    //             return ShipLaborWork.api().fetch(shipId)
    //         })
    //         .then(() => {
    //             return SelectShip.api().fetch(this.organizationId)
    //         })
    //         .catch(() => {
    //             return new Promise((resolve, reject) => {
    //                 reject(new Error())
    //             })
    //         })
    // }
}
